import { Logo } from "../Logo";
import { SocialIcons } from "../SocialIcons";
import Link from "../tailwind/Link";

export const MainPageFooter = () => (
  <div className="w-full flex flex-col items-center justify-center pt-40 pb-20 gap-5">
    <div className="flex flex-col gap-5 items-center">
      <Link
        analyticsId="click logo"
        analyticsProps={{
          where: "footer",
        }}
        href="/#"
      >
        <Logo className="w-[208px]" />
      </Link>
      <SocialIcons />
    </div>
  </div>
);
